import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

// Utils
// @ts-ignore
import { Form, FormElements } from '@zolteam/zol-react-form';
// Components
// @ts-ignore
import { Box, Button, Message } from '@zolteam/zol-admin-ui';
// Assets
// eslint-disable-next-line import/no-unresolved
import Logo from '../../assets/logo-black.svg?react';
// Locales
import fr from '../../locales/fr.json';
// Hooks
import { useAuth } from '../../domain/auth/useAuth';
import { getErrorMessage } from '../../utils/errors/displayError';

const FORM_NAME = 'login';

/**
 * Login View
 * @returns {JSX.Element}
 */
function Login() {
  // Hooks
  const { t } = useTranslation();
  const { loginMutation } = useAuth();

  // schema
  const SCHEMA = {
    $schema: 'https://json-schema.org/draft/2020-12/schema',
    type: 'object',
    title: 'Login',
    properties: {
      email: {
        type: 'string',
        format: 'email',
        description: t('login.fields.email'),
        x_layout: '1/1/1/13',
      },
      password: {
        type: 'string',
        format: 'password',
        description: t('login.fields.password'),
        x_layout: '2/1/2/13',
        minLength: '8',
      },
    },
    required: [
      'email',
      'password',
    ],
    additionalProperties: false,
  };

  // Services
  const { mutate: loginMutate, isLoading: isLoadingLogin } = loginMutation;

  // Actions
  /**
   * Submit the form.
   * @param {object} data
   * @param {string} data.email
   * @param {string} data.password
   * @returns {void}
   */
  const onSubmit = (data) => {
    loginMutate(data);
  };

  return (
    <Box direction="column" gap="m" fullWidth>
      <Box direction="column" align="center" fullWidth className="margin-bottom-m margin-top-xl">
        <Logo />
      </Box>
      <Box direction="column" gap="xs" align="center" fullWidth>
        <h1 className="h3-default font-weight-bold">
          {t('login.title')}
        </h1>
        <span className="p1-default">
          {t('login.description')}
        </span>
        {loginMutation.isError ? (
          <div className="margin-bottom-m">
            <Message>
              {getErrorMessage(loginMutation.error
              // @ts-ignore
                .code)}
            </Message>
          </div>
        ) : null}
      </Box>

      <Box fullWidth>
        <Form
          name={FORM_NAME}
          callbacks={{
            onSubmit,
          }}
          schema={SCHEMA}
          translations={{ formValidation: fr.formValidation }}
          defaultValues={{
            email: '',
            password: '',
          }}
        >
          {
          (formConfig, formInfo) => (
            <FormElements
              translations={null}
              formConfig={formConfig}
              formTitle={formInfo.formName}
            />
          )
}
        </Form>
      </Box>

      <Box direction="column" gap="xs" align="normal" fullWidth>
        <Button
          form={FORM_NAME}
          isSubmit
          isLoading={isLoadingLogin}
        >
          {t('login.actions.submit')}
        </Button>

        <Button color="noBackground">
          <Link to="/reset-password">
            {t('login.actions.forgotPassword')}
          </Link>
        </Button>
      </Box>
    </Box>
  );
}

export default Login;
